<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
    <el-row class="flex">
      <el-input
        size="small"
        v-model="keyWord"
        clearable
        placeholder="请输入模型名称或编码"
        class="mr-10px w-200px"
      />
      <el-button type="primary" @click="getTableData()">{{ $t('search') }}</el-button>
      <el-button type="primary" :disabled="!$hasAccess('create')" @click="toModelDetail('add')"
        >新增模型</el-button
      >
    </el-row>
    <el-table
      class="mt-20px"
      border
      :data="tableData"
      v-loading="loading"
      :highlight-current-row="true"
      height="calc(100% - 102px)"
      ref="multipleTable"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="序号" type="index" width="55"></el-table-column>
      <el-table-column label="模型名称" prop="name" show-overflow-tooltip></el-table-column>
      <el-table-column label="模型编码" prop="code" show-overflow-tooltip></el-table-column>
      <el-table-column label="描述" prop="description" show-overflow-tooltip> </el-table-column>
      <el-table-column label="创建人" prop="createdUserName" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="指标状态" prop="isPublish" width="130">
        <template slot-scope="scope">
          <span v-if="scope.row.isPublish">已发布</span>
          <span v-else>已关闭</span>
          <el-switch v-model="scope.row.isPublish" @change="updatePublish(scope.row)"> </el-switch>
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('operate')}`" width="300">
        <template slot-scope="scope" class="flex">
          <el-tooltip
            placement="top"
            content="请先关闭后再进行编辑"
            :disabled="!scope.row.isPublish"
          >
            <span class="w-50px mr-10px">
              <el-button
                size="mini"
                :disabled="!$hasAccess('update') || scope.row.isPublish"
                @click="toModelDetail('update', scope.row.id)"
                >{{ $t('edit') }}</el-button
              >
            </span>
          </el-tooltip>
          <el-tooltip
            placement="top"
            content="请先关闭后再进行删除"
            :disabled="!scope.row.isPublish"
          >
            <span class="w-50px mr-10px">
              <el-button
                size="mini"
                :disabled="!$hasAccess('delete') || scope.row.isPublish"
                @click="deleteModel(scope.row)"
                >{{ $t('delete') }}</el-button
              >
            </span>
          </el-tooltip>
          <el-button
            size="mini"
            :disabled="!$hasAccess('copy')"
            @click="toModelDetail('copy', scope.row.id)"
            >复制</el-button
          >
          <el-button
            size="mini"
            :disabled="!$hasAccess('preview')"
            @click="toDataPreview(scope.row)"
            >数据预览</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt-20px float-right"
      background
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      :current-page.sync="page.pageNo"
      :page-size="page.pageSize"
      :page-sizes="$pageSizeAll"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.total"
    ></el-pagination>

    <!-- 编辑和删除的提示弹窗 -->
    <el-dialog
      title="提示！"
      :visible.sync="visiable"
      class="small-dialog"
      v-dialogDrag
      :close-on-click-modal="false"
    >
      <div class="text-16px">{{ operateTitle }}</div>
      <div class="text-16px mt-10px">关联指标如下：</div>
      <div class="mt-10px overflow-auto">
        <div class="mt-5px text-color" v-for="(value, key, index) in errMsg" :key="index">
          <span @click="toMetricsDetail(value)" class="cursor-pointer">【{{ value.name }}】</span>
        </div>
      </div>
      <div slot="footer">
        <el-button v-if="showConfirmBtn" @click="confirmEdit" type="primary">{{
          confirmButtonText
        }}</el-button>
        <el-button @click="visiable = false">取消</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import DataModelService from '@/services/DataModelService'

export default {
  name: 'ModelDevelopment',
  data() {
    return {
      keyWord: '',
      tableData: [],
      loading: false,
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      visiable: false,
      showConfirmBtn: false,
      confirmButtonText: '',
      operateTitle: '',
      errMsg: {},
      currentId: '',
      currentType: '',
    }
  },
  computed: {
    // 兼容除saas其他项目使用该模块
    basePath() {
      return _.get(Wiz, 'globalSettings.globalConfig.routerBase')
        ? `/${Wiz.globalSettings.globalConfig.routerBase}`
        : ''
    },
  },
  methods: {
    showDialog(type) {
      this.visiable = true
      if (type === 'update') {
        this.operateTitle = '编辑后会导致已发布的指标数据无法展示！'
        this.showConfirmBtn = true
        this.confirmButtonText = '继续编辑'
      } else if (type === 'delete') {
        this.operateTitle = '数据模型已关联指标，请先删除关联指标，再删除数据模型！'
        this.showConfirmBtn = false
      } else if (type === 'publish') {
        this.operateTitle = '请先关闭关联指标！'
        this.showConfirmBtn = false
      }
    },
    // 继续编辑
    confirmEdit() {
      this.visiable = false
      this.$router.push(`./add-model?id=${this.currentId}&type=update`)
    },
    // 跳转指标详情页或指标列表页
    toMetricsDetail(row) {
      this.visiable = false
      let path = ''
      if (row.type === 0) {
        // 原子指标
        path = 'atomic-indicators'
      } else if (row.type === 1) {
        // 派生指标
        path = 'derived-metrics'
      } else if (row.type === 2) {
        // 复合指标
        path = 'composite-metrics'
      }
      if (this.currentType === 'update') {
        this.$router.push(
          `${this.basePath}/legacy-resource/data-metrics/${path}?id=${row.id}&type=update`
        )
      } else {
        this.$router.push(
          `${this.basePath}/legacy-resource/data-metrics/metrics-management?dataModelId=${this.currentId}&metricsDmainId=${row.metricsDmainId}&metricsId=${row.id}`
        )
      }
    },
    // 获取列表数据
    async getTableData() {
      this.loading = true
      const res = await DataModelService.getList({
        NameOrCode: this.keyWord,
        Sorting: 'created_time desc',
        SkipCount: (this.page.pageNo - 1) * this.page.pageSize,
        MaxResultCount: this.page.pageSize,
      })
      this.loading = false
      if (res && res.code === 0 && res.data) {
        this.tableData = res.data
        this.page.total = res.totalCount
      }
    },
    // 修改当前页
    handleCurrentChange(num) {
      this.page.pageNo = num
      this.getTableData()
    },
    // 修改页码
    handleSizeChange(size) {
      this.page.pageSize = size
      this.getTableData()
    },
    // 跳转模型详情页
    async toModelDetail(type, id) {
      this.currentId = id
      this.currentType = type
      if (type === 'update') {
        // 校验是否关联指标
        this.errMsg = {}
        this.errMsg = await this.isExistDepend(id)
        if (!_.isEmpty(this.errMsg)) {
          this.showDialog('update')
        } else {
          this.$router.push(`./add-model?id=${id}&type=${type}`)
        }
      } else if (type === 'add') {
        this.$router.push(`./add-model?type=${type}`)
      } else if (type === 'copy') {
        this.$router.push(`./add-model?id=${id}&type=${type}`)
      }
    },
    // 删除模型
    async deleteModel(row) {
      this.currentId = row.id
      this.currentType = 'delete'
      // 校验是否关联指标
      this.errMsg = {}
      this.errMsg = await this.isExistDepend(row.id)
      if (!_.isEmpty(this.errMsg)) {
        this.showDialog('delete')
      } else {
        this.$confirm('是否确定要删除该模型', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const res = await DataModelService.deleteModel(row.id)
          if (res && res.code === 0) {
            this.$message.success('删除模型成功')
            this.getTableData()
          }
        })
      }
    },
    // 修改发布状态
    async updatePublish(row) {
      this.currentId = row.id
      // 校验是否关联指标
      const isPublish = row.isPublish
      // 当模型关闭时，需要校验是否存在已发布的依赖指标
      this.errMsg = {}
      if (!isPublish) {
        this.errMsg = await this.isExistDepend(row.id, !row.isPublish)
      }
      if (!_.isEmpty(this.errMsg)) {
        this.showDialog('publish')
        const index = _.findIndex(this.tableData, ['id', row.id])
        this.tableData[index].isPublish = !this.tableData[index].isPublish
      } else {
        const res = await DataModelService.updatePublish({ isPublish: row.isPublish, id: row.id })
        if (res && res.code === 0) {
          this.$message.success('修改状态成功')
          this.getTableData()
        }
      }
    },
    // 跳转数据预览页面
    toDataPreview(row) {
      this.$router.push({
        path: './data-preview',
        query: {
          id: row.id,
          name: row.name,
          code: row.code,
        },
      })
    },
    // 是否存在依赖
    async isExistDepend(id, isPublish) {
      const res = await DataModelService.isExistDepend({
        id,
        isPublish,
      })
      if (res && res.code === 0 && res.details) {
        return res.details
      }
      return {}
    },
  },
  created() {
    this.getTableData()
  },
}
</script>

<style lang="scss" scoped>

.text-color {
  color: var(--systemMainColor);
}

</style>
